// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ttx8","vLegacy":"SelectSecondary_vLegacy__3ijJV","error":"SelectSecondary_error__1haBH","disabled":"SelectSecondary_disabled__1JNg_"};